addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("section.marquee").forEach(marquee => {
    const div = document.createElement("div")
    div.className = "marquee-sub"
    div.append(...marquee.children)
    marquee.append(div)
    marquee.append(div.cloneNode(true))
    const measure = div.cloneNode(true)
    measure.classList.add("marquee-measure")
    marquee.append(measure)
    if (marquee.dataset.speed) {
      marquee.dataset.marquee = Math.random()
      const style = document.createElement("style")
      style.textContent = `
        [data-marquee="${marquee.dataset.marquee}"].marquee.scrolling .marquee-sub {
          animation: marquee ${parseFloat(marquee.dataset.speed)}s linear infinite;
        }
      `
      document.body.appendChild(style)
    }
    marquee.classList.add("initialised")
    const adjust = () => marquee.classList.toggle("scrolling", measure.clientWidth > marquee.clientWidth)
    adjust()
    window.addEventListener("resize", adjust)
  })
});

